import { useEffect, useRef, useState } from "react"
import { getExport } from "helpers/api_helper"

export const EXPORT_FAILED = "The XLSX could not be downloaded. Try again."
// The file name the gateway gives an export, or the fallback.
const fileName = (headers, fallback) => headers?.["content-disposition"]?.match(/filename="([^"]+)"/i)?.[1] || fallback

// Saves a Logistics XLSX the gateway builds, such as the Sheets page's or a sheet's, or the PDF of Cargus labels: one download at a time,
// an answer that is not a file refused, and the failure (`failed`) kept until the next try or its dismissal.
export default function useXlsxDownload(failed = EXPORT_FAILED) {
  const [state, setState] = useState({ busy: false, error: "" })
  const alive = useRef(true)
  useEffect(() => () => { alive.current = false }, [])
  const download = async (url, config, fallback) => {
    if (state.busy) return
    setState({ busy: true, error: "" })
    let objectUrl
    try {
      const response = await getExport(url, { ...config, responseType: "blob" })
      if (!(response?.data instanceof Blob) || response.data.size === 0 || /json|html/.test(response.data.type)) throw new Error("Invalid export")
      if (!alive.current) return
      objectUrl = URL.createObjectURL(response.data)
      const link = document.createElement("a")
      link.href = objectUrl
      link.download = fileName(response.headers, fallback)
      document.body.appendChild(link)
      link.click()
      link.remove()
      setState({ busy: false, error: "" })
    } catch {
      if (alive.current) setState({ busy: false, error: failed })
    } finally {
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }
  return { ...state, download, dismiss: () => setState({ busy: false, error: "" }) }
}
